'use client';

import { Dialog, Transition } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

import { useHeaderStore } from '@lib/stores/useHeaderStore';

interface ExpandedMenuProps {
  children: ReactNode;
}

export function ExpandedMenu({ children }: Readonly<ExpandedMenuProps>) {
  const { openSheet, setOpenSheet } = useHeaderStore();

  return (
    <Transition show={openSheet} as={Fragment}>
      <Dialog as='div' className='relative z-40' onClose={setOpenSheet}>
        {children}
      </Dialog>
    </Transition>
  );
}
